import { css } from "@emotion/react";
import { COLORS } from "./styles/colors";

const GlobalStyles = css`
  /* Neue Frutiger World Font Faces */
  @font-face {
    font-family: "NeueFrutigerWorld-thin";
    font-style: normal;
    font-weight: 100;
    src: url("/fonts/NeueFrutigerWorld-Thin.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "NeueFrutigerWorld-medium";
    font-style: normal;
    font-weight: 400;
    src: url("/fonts/NeueFrutigerWorld-Medium.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "NeueFrutigerWorld-medium1";
    font-style: normal;
    font-weight: 500;
    src: url("/fonts/NeueFrutigerWorld-Medium.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "NeueFrutigerWorld-bold";
    font-style: normal;
    font-weight: 600;
    src: url("/fonts/NeueFrutigerWorld-XtraBlk.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "NeueFrutigerWorld";
    font-style: normal;
    font-weight: 800;
    src: url("/fonts/NeueFrutigerWorld-XtraBlk.ttf") format("truetype");
    font-display: swap;
  }

  /* Original Inter Numeric Font Faces (keep these if still needed) */
  /* @font-face {
    font-family: "Inter Numeric";
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/l/font?kit=UcC73FwrK3iLTeHuS_fvQtMwCp50KnMq14DyQXcDrOAgjkPkKFrz&skey=c491285d6722e4fa&v=v12)
      format("woff2");
    font-display: swap;
  }

  @font-face {
    font-family: "Inter Numeric";
    font-style: normal;
    font-weight: 500;
    src: url(https://fonts.gstatic.com/l/font?kit=UcC73FwrK3iLTeHuS_fvQtMwCp50KnMq14DyQXcDrOAgjkPkKFrz&skey=c491285d6722e4fa&v=v12)
      format("woff2");
    font-display: swap;
  }

  @font-face {
    font-family: "Inter Numeric";
    font-style: normal;
    font-weight: 600;
    src: url(https://fonts.gstatic.com/l/font?kit=UcC73FwrK3iLTeHuS_fvQtMwCp50KnMq14DyQXcDrOAgjkPkKFrz&skey=c491285d6722e4fa&v=v12)
      format("woff2");
    font-display: swap;
  } */

  /* Base Styles */
  html,
  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: "NeueFrutigerWorld-medium";
  }

  body {
    background-color: ${COLORS.CustomGreen};
    color: ${COLORS.White};
  }

  /* Font Smoothing for Light Weights */
  @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 144dpi) {
    body {
      -webkit-font-smoothing: subpixel-antialiased;
    }
  }
`;

export default GlobalStyles;
